import config from "../config";
import { getActions, getType, getTypes, OBJECT_DELETE } from "../helpers/crudActions";
import HttpClient, { CancelToken } from "../helpers/httpclient";
import { cancelFetchRequests } from "../helpers/util";

export default {
  ...getActions("SECURITY_RESTRICTIONS", "security-restrictions"),
  ...getTypes("SECURITY_RESTRICTIONS"),
  redirect(response) {
    return response;
  },
};

export const SECURITIES_AFTER_SAVE = "SECURITIES_AFTER_SAVE";
export const SECURITIES_REMOVE_AFTER_SAVE = "SECURITIES_REMOVE_AFTER_SAVE";

export function removeAfterSave() {
  return { type: SECURITIES_REMOVE_AFTER_SAVE };
}

export async function fetchNotes(id) {
  const r = await HttpClient.get(`${config.api}/security-restrictions/${id}/notes`);
  return r.data;
}

export async function fetchExists(account, security) {
  const params = { params: { account, security } };
  const r = await HttpClient.get(`${config.api}/security-restrictions/exists`, params);
  return r.data;
}

export function deleteRestrictions(ids) {
  const params = { params: { ids } };
  return {
    type: getType(OBJECT_DELETE, "SECURITY_RESTRICTIONS"),
    payload: HttpClient.delete(`${config.api}/security-restrictions`, params),
  };
}

// Store cancellation tokens per restriction type
const cancelTokens = {};

export async function fetchRestrictions(page, status = "all", options = {}) {
  const restrictionType = options.restriction || "all";

  // Cancel previous requests for this specific restriction type
  if (cancelTokens[restrictionType] && cancelTokens[restrictionType].length !== 0) {
    cancelFetchRequests(cancelTokens[restrictionType]);
  }

  // Initialize cancel array for this type if it doesn't exist
  if (!cancelTokens[restrictionType]) {
    cancelTokens[restrictionType] = [];
  }

  const params = {
    cancelToken: new CancelToken(function executor(c) {
      cancelTokens[restrictionType].push(c);
    }),
    params: { page, status, ...options },
  };

  const r = await HttpClient.get(`${config.api}/security-restrictions`, params);
  return r.data;
}

export function fetchAllRestrictionIds(options = {}) {
  return async (_dispatch) => {
    try {
      // First, get the total count to calculate pages
      const initialParams = { params: { page: 1, status: "all", ...options } };
      const initialResponse = await HttpClient.get(`${config.api}/security-restrictions`, initialParams);

      const totalCount = initialResponse.data.count;
      const pageSize = initialResponse.data.pageSize || 50; // Default page size
      const totalPages = Math.ceil(totalCount / pageSize);

      // Fetch all pages in parallel
      const pagePromises = [];
      for (let page = 1; page <= totalPages; page++) {
        const params = { params: { page, status: "all", ...options } };
        pagePromises.push(HttpClient.get(`${config.api}/security-restrictions`, params));
      }

      const responses = await Promise.all(pagePromises);

      // Extract all restriction objects from all pages
      const allRestrictions = [];
      responses.forEach((response) => {
        if (response.data?.objects) {
          response.data.objects.forEach((restriction) => {
            allRestrictions.push(restriction);
          });
        }
      });

      return allRestrictions;
    } catch (error) {
      console.error("Error fetching all restrictions:", error);
      throw error;
    }
  };
}
